module.exports = __webpack_public_path__ + "static/media/02_tn.c5b09979.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/02_tn.jpg
// module id = 311
// module chunks = 0